import { Component, OnInit } from '@angular/core';
import { Router,RouterModule } from '@angular/router';
import { KJUR } from 'jsrsasign';
import { UserManagementService } from '../../../service/user-management.service';
import { CommonModule } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { SharedApplicantService } from '../../services/shared-applicant.service';
import { UserService } from '../../services/user.service';
import { FcmService } from '../../services/fcm.service';
import { SharedCaseManagementService } from '../../services/shared-case-management.service';

@Component({
  selector: 'app-eg-nav-bar',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './eg-nav-bar.component.html',
  styleUrl: './eg-nav-bar.component.scss',
})
export class EgNavBarComponent implements OnInit {
  currentRoute: string = '';
  isAdmin : boolean = false;
  isSuperAdmin : boolean = false;
  decoded: any;
  isEligibilityAutoDetermined: boolean = true;
  showNavBar: boolean = true;

  /** Prevents duplicate XHR calls when the component is destroyed/re-created by *ngIf on route changes. */
  private static _initialized: boolean = false;

  /** Call this on logout so the next login triggers a fresh fetch. */
  static resetInitialized(): void {
    EgNavBarComponent._initialized = false;
  }

  constructor(private readonly router: Router, private readonly userManagementService: UserManagementService, private readonly toastr: ToastrService, private readonly sharedApplicantService: SharedApplicantService,
    private readonly userService: UserService, private readonly fcmService: FcmService, private  readonly sharedCaseManagementService: SharedCaseManagementService
  ) {}

  ngOnInit(): void {
    // Only fire XHR calls once per browser session across all component instantiations.
    if (EgNavBarComponent._initialized) {
      // Restore instance-level flags from sessionStorage so nav items render correctly
      this.isAdmin = sessionStorage.getItem('isAdmin') === 'true';
      this.isSuperAdmin = sessionStorage.getItem('isSuperAdmin') === 'true';
      const stored = sessionStorage.getItem('isEligibilityAutoDetermined');
      if (stored !== null) {
        this.isEligibilityAutoDetermined = stored === 'true';
      }
      return;
    }

    if (
      window.location.href.includes('=') &&
      window.location.href.includes('id_token')
    ) {
      const token = window.location.href.split('=')[1];
      try {
        this.decoded = KJUR.jws.JWS.parse(token);
        EgNavBarComponent._initialized = true;
        this.getAgencyId();
        setTimeout(() => {
          if (!window.location.href.includes('account-setup-success')) {
            this.getUserRole();
          }
        }, 1000);
      }
      catch (error) {
        console.error('Error decoding JWT:', error);
      }
    }
    else if (sessionStorage.getItem('isAdmin') || sessionStorage.getItem('isSuperAdmin')) {
      this.decoded = KJUR.jws.JWS.parse(sessionStorage.getItem('applicationToken'));
      EgNavBarComponent._initialized = true;
      this.getAgencyId();
      setTimeout(() => {
        if (!window.location.href.includes('account-setup-success')) {
          this.getUserRole();
        }
      }, 1000);
    }
  }

  getAgencyId() {
    const currentUrl = window.location.href;
    const baseUrl = new URL(currentUrl).host;
    
    this.userManagementService.getAgencyId(baseUrl).subscribe(
      (data: any) => {
      const agencyId = data?.agencyId;
      const agency = data;
      if (agencyId) {
        sessionStorage.setItem('agencyId', agencyId);
      }
      if (agency) {
        sessionStorage.setItem('agency', JSON.stringify(agency));
        this.isEligibilityAutoDetermined = data?.eligibilityAutoDetermined;
        this.userService.setEligibilityAutoDetermined(this.isEligibilityAutoDetermined);
        if (!sessionStorage.getItem('isEligibilityAutoDetermined')) {
          sessionStorage.setItem('isEligibilityAutoDetermined', this.isEligibilityAutoDetermined.toString());
        }
      }
      if(localStorage.getItem('caseView')) {
        if(window.location.href.includes('preview-application-form')) {
          this.showNavBar = false;
        }
      }
      },
      (error: any) => {
        console.error('There was an error fetching agency id:', error);
        this.toastr.error('There was an error fetching agency id. Please try again.');
      }
    );
  }
  isDisabled: boolean = true;
  getUserRole() {
    let email = '';
    if(this.decoded.payloadObj?.emails) {
      email = this.decoded.payloadObj.emails[0];
    }
    else if(this.decoded.payloadObj?.email) {
      email = this.decoded.payloadObj.email;
    }
    this.userManagementService.findByEmailUser(email).subscribe((data:any) => {
      if (!data || Object.keys(data)?.length === 0) {
        console.log(data);
      } else if (data) {
        this.sharedApplicantService.changeUserRole(data.role);
        sessionStorage.setItem('userRole', data.role);
        if(data.role === 'SUPER_ADMIN') {
          this.isSuperAdmin = true;
          this.isAdmin = false;
        }
        else if(data.role === 'ADMIN') {
          this.isAdmin = true;
          this.isSuperAdmin = false;
        }
        else {
          this.isAdmin = false;
          this.isSuperAdmin = false;
        }
        if (!sessionStorage.getItem('isAdmin')) {
          sessionStorage.setItem('isAdmin', this.isAdmin.toString());
        }
        if (!sessionStorage.getItem('isSuperAdmin')) {
          sessionStorage.setItem('isSuperAdmin', this.isSuperAdmin.toString());
        }
        const userId = data?.userId;
        if (userId) {
          sessionStorage.setItem('userId', userId);
        }
        sessionStorage.setItem('email', email);
        /* if(!this.isEligibilityAutoDetermined) {
          this.fcmService.requestPermissionAndGetToken$().subscribe((token: any) => {
          if (token) {
            this.sharedCaseManagementService.changeFcmToken(token);
            sessionStorage.setItem('fcmToken', token);
          } else {
            console.warn('⚠️ No FCM token available.');
          }
          });
        } */
        this.isDisabled = false;
      }
      },
      (error: any) => {
        this.isDisabled = false;
        console.log(error);
        this.userManagementService.redirectToLogin(error,email);
      }
    );
  }

  onHomeMenuClick() {
    this.router.navigate(['/dashboard']);
  }

  onApplicantMenuClick() {
    this.router.navigate(['/applicant-list']);
  }

}
